import { schema } from "normalizr";
import { COMPANY_SCHEMA } from "./index";

export default new schema.Entity(COMPANY_SCHEMA);
